// imports
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';

// interfaces / types / consts
const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG as string);
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export type EventName = 'CONNECT_WALLET' |
  'PLAY_GAME' |
  'CALL_TO_ACTION' |
  'SOCIAL_MEDIA_LINK' |
  'DELEGATE_WALLET' |
  'ACTIVATE_HEROES' |
  'DEACTIVATE_HEROES' |
  'REGION_PIN' |
  'QUEST_PIN' |
  'QUEST_BUTTON' |
  'QUEST_ITEM' |
  'QUEST_START' |
  'HERO_SENT' |
  'COST_SPENT' |
  'REWARD_CLAIM' |
  'REWARD_ITEM_ADD' |
  'HERO_RETURNED';
type EventAction = 'CLICK' | 'SELECT' | 'SUCCESS';

type EventBody = {
  name: EventName;
  action: EventAction;
  eventParams?: { [key: string]: unknown } | undefined;
};

type userPropertiesBody = {
  walletId: `0x${string}`;
  tokensLocked?: number;
};

// exports
export const logAnalytics = (event: EventBody): void => {
  const { name, action, eventParams } = event;
  let params = eventParams || {};
  params = { timestamp: Date.now(), ...params };
  logEvent(analytics, `${name}_${action}`, params);
};

export const logUserProperties = (body: userPropertiesBody): void => {
  setUserProperties(analytics, body);
};

export default {
  logAnalytics,
  logUserProperties
};
